export default __webpack_public_path__ + "static/media/amazon-original.e4e74128.svg";